import React, { useState } from 'react';
import { API_URL } from '../../actions';
import { useGlobalContext } from '../context/GlobalContext';
import SelectMedia from '../pages/medias/SelectMedia';

const TITLE_MAX = 60;
const DESC_MAX = 160;

export default function MetaSeo({ seo, onChange, theme, companyId }) {
  const [context, dispatch] = useGlobalContext();
  const [isOpen, setIsOpen] = useState(false);
  const [displaySelectMedia, setDisplaySelectMedia] = useState(false);

  const metaTitle = seo?.metaTitle || '';
  const metaDescription = seo?.metaDescription || '';
  const metaImage = seo?.metaImage || null;

  function handleFieldChange(field, value) {
    onChange({ ...seo, metaTitle, metaDescription, metaImage, [field]: value });
  }

  function handleImageSelect(value) {
    if (value && value.length > 0) {
      handleFieldChange('metaImage', value[0]);
    }
  }

  function renderImage() {
    if (!metaImage) return null;
    const imageId = metaImage?._id || metaImage;
    const found = context?.medias?.mediasList?.find(item => item._id === imageId);
    if (found) {
      return <img src={API_URL + '/' + found.path} alt="meta" style={{ maxWidth: 300, maxHeight: 160, marginTop: 10 }} />;
    }
    if (metaImage?.path) {
      return <img src={API_URL + '/' + metaImage.path} alt="meta" style={{ maxWidth: 300, maxHeight: 160, marginTop: 10 }} />;
    }
    return null;
  }

  return (
    <div className="meta-seo-section" style={{ margin:20, marginTop: 30, borderTop: '1px solid #e0e0e0', paddingTop: 20 }}>
      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', marginBottom: isOpen ? 20 : 0 }}
      >
        <h3 style={{ margin: 0 }}>Référencement SEO</h3>
        <span style={{ marginLeft: 10, fontSize: 12 }}>{isOpen ? '▲' : '▼'}</span>
      </div>

      {isOpen && (
        <div>
          <label htmlFor="metaTitle">
            Titre SEO
            <span style={{ fontSize: 12, color: metaTitle.length > TITLE_MAX ? '#e53935' : '#888', marginLeft: 8 }}>
              {metaTitle.length}/{TITLE_MAX}
            </span>
          </label>
          <input
            id="metaTitle"
            name="metaTitle"
            value={metaTitle}
            onChange={(e) => handleFieldChange('metaTitle', e.target.value)}
            placeholder="Titre affiché dans les résultats Google"
            style={{ marginBottom: 10 }}
          />

          <label htmlFor="metaDescription">
            Description SEO
            <span style={{ fontSize: 12, color: metaDescription.length > DESC_MAX ? '#e53935' : '#888', marginLeft: 8 }}>
              {metaDescription.length}/{DESC_MAX}
            </span>
          </label>
          <textarea
            id="metaDescription"
            name="metaDescription"
            value={metaDescription}
            onChange={(e) => handleFieldChange('metaDescription', e.target.value)}
            placeholder="Description affichée dans les résultats Google"
            rows={3}
            style={{ marginBottom: 10 }}
          />

          <label>Image SEO <span className="note">Image affichée en miniature dans les résultats de recherche et les partages sociaux</span></label>
          <div className="btn-container" style={{ marginBottom: 10 }}>
            <button
              type="button"
              className={`btn primary ${theme}-bg`}
              style={{ marginRight: 20 }}
              onClick={() => setDisplaySelectMedia(true)}
            >
              Parcourir
            </button>
            {metaImage && (
              <button
                type="button"
                className={`btn primary ${theme}-bg`}
                onClick={() => handleFieldChange('metaImage', null)}
              >
                Supprimer
              </button>
            )}
          </div>
          {renderImage()}

          {displaySelectMedia && (
            <SelectMedia
              displaySelectMedia={displaySelectMedia}
              dispatch={dispatch}
              theme={theme}
              context={context}
              mediaType="image"
              selectedMediaList={metaImage ? [metaImage._id || metaImage] : []}
              companyId={companyId}
              isMulti={false}
              handleChange={(value) => handleImageSelect(value)}
              setDisplaySelectMedia={setDisplaySelectMedia}
            />
          )}
        </div>
      )}
    </div>
  );
}
